import { useTranslation } from 'react-i18next';

import { categoryGroups } from '~/vendor/cx-modules/constants';

const TEAM_SEPARATORS = [' v ', ' at '] as const;

function extractTeamsFromSubeventName(subeventName: string) {
  for (const separator of TEAM_SEPARATORS) {
    const teams = subeventName.split(separator);
    if (teams.length === 2) {
      const [first, second] = teams.map(team => team.trim());
      return { first, second, separator, success: true as const };
    }
  }
  return { first: '', second: '', separator: '', success: false as const };
}

/**
 * Translates/regionalises a subevent name (e.g. "Mexico v South Africa") the same
 * way the betslip does in @cx-web/feature-betslip's `bet.tsx`, so a result card's
 * accessible name matches the bet it adds to the betslip (e.g. GZ → "Messico v Sudafrica").
 */
export function useTranslatedSubeventName(categoryGroupName: string, subeventName: string): string {
  const translationFile = categoryGroups.find(cg => cg.name === categoryGroupName)?.translationFile;

  const ns = [translationFile, 'label', 'bettype'].filter(Boolean) as string[];
  const { t } = useTranslation(ns);

  if (!subeventName) return '';

  const { first, second, separator, success } = extractTeamsFromSubeventName(subeventName);

  if (success) return `${t(first)}${t(separator, { ns: 'label' })}${t(second)}`;
  return t(subeventName);
}
